import { Button, MenuItem, TextField } from "@material-ui/core";
import { useEffect, useState } from "react";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import axios from "axios";
import { decodeAnswer } from "../../helpers/jwt";
import "./Questions.css";
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

const Questions = ({ quiz }) => {
  const [questions, setQuestions] = useState([]);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [question, setQuestion] = useState("");
  const [correctAns, setCorrectAns] = useState("");
  const [incorrectAns1, setIncorrectAns1] = useState("");
  const [incorrectAns2, setIncorrectAns2] = useState("");
  const [incorrectAns3, setIncorrectAns3] = useState("");
  const [questionType, setQuestionType] = useState('');
  const [image, setImage] = useState('');
  const [notDisabled, setNotDisabled] = useState([]);
  const types = ['Multiple Choice', 'Identification', 'True or False'];
  const [open, setOpen] = useState(false);

  const useStyles = makeStyles((theme) => ({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    fields: {
      padding: '0px',
    }
  }));

  const classes = useStyles();

  useEffect(() => {
    quiz.questions = quiz.questions.map(question => {
      question.correct_answer = decodeAnswer(question.correct_answer);
      question.incorrect_answers = question.incorrect_answers.map(incorrect => decodeAnswer(incorrect))
      return question;
    });
    setQuestions(quiz.questions)
  }, [quiz]);

  const handleInsertQuestion = async () => {
    if (!question || !questionType || !correctAns) {
      setError(true);
      setErrorMsg('Please fill all the fields')
      return;      
    } else {
      setError(false);
      try {
        const { data } = await axios.patch(`https://computer-quiz-backend.herokuapp.com/quizzes/${quiz._id}`,
          {
            "questions": [
              {
                "toAdd": true,
                "quiz_name": quiz.quiz_name,
                "correct_answer": correctAns,
                "type": questionType,
                "image_link": image,
                "incorrect_answers": [incorrectAns1, incorrectAns2, incorrectAns3].filter(element => element),
                question
              }
            ]
          },
          {
            headers: { 'api-token': localStorage.getItem('token') }
          }
        );
        data.questions = data.questions.map(question => {
          question.correct_answer = decodeAnswer(question.correct_answer);
			    question.incorrect_answers = question.incorrect_answers.map(incorrect => decodeAnswer(incorrect))
          return question;
        });
        handleReset();
        setQuestions(data.questions);
        setOpen(false);
      } catch (error) {
        setError(true);
        setOpen(false);
        setErrorMsg(JSON.stringify(error?.response?.data));
      }
    }
  };

  const handleReset = () => {
    setQuestion("");
    setCorrectAns("");
    setIncorrectAns1("");
    setIncorrectAns2("");
    setIncorrectAns3("");
    setQuestionType("");
    setImage("");
  };

  const handleDisableQuestion = (index) => {
      setNotDisabled([...notDisabled, index]);
  };

  const handleUpdateQuestion = async (index, toDelete = false) => {
    // update call
    let incorrectAns = questions[index].incorrect_answers;
    if (incorrectAns1.length) incorrectAns[0] = incorrectAns1;
    if (incorrectAns2.length) incorrectAns[1] = incorrectAns2;
    if (incorrectAns3.length) incorrectAns[2] = incorrectAns3;

    let options = {
      "_id": questions[index]._id,
      "correct_answer": correctAns ? correctAns : questions[index].correct_answer,
      "type": questionType ? questionType : questions[index].type,
      "image_link": image ? image : questions[index].image_link,
      "incorrect_answers": incorrectAns,
      "question": question ? question : questions[index].question
    };
    if (toDelete) {
      options = {
        "_id": questions[index]._id,
        "toDelete": true
      }
    }
    const { data } = await axios.patch(`https://computer-quiz-backend.herokuapp.com/quizzes/${quiz._id}`,
          {
            "questions": [
              options
            ]
          },
          {
            headers: { 'api-token': localStorage.getItem('token') }
          }
        );
        data.questions = data.questions.map(question => {
          question.correct_answer = decodeAnswer(question.correct_answer);
			    question.incorrect_answers = question.incorrect_answers.map(incorrect => decodeAnswer(incorrect))
          return question;
        });
        handleReset();
        setQuestions(data.questions);
    // after save, disable
    const spliced = notDisabled.filter(item => item !== index);
    setNotDisabled([...spliced]);
  };

  const checkDisabled = (index) => {
    if (notDisabled.length && notDisabled.includes(index)) return false;
    return true;
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    handleReset();
  };

  return (
    <div>
      <div className="questionSetting">
      { questions.length !== 0 && 
        <span style={{ fontSize: 30, position: 'absolute' }}>Questions</span>
      }
      { questions.length !== 0 &&
        <div className="fab">
          <Fab color="primary" aria-label="add" onClick={handleOpen}>
            <AddIcon/>
          </Fab>
        </div>
      }
        {
          questions.length !== 0 &&
          <div className="questionsContent">
            { questions.map((question, index) => (
              <div className="settings__questions">
                {index + 1}.
                <TextField
                  disabled={checkDisabled(index)}
                  size="small"
                  className={classes.fields}
                  style={{ marginBottom: 15 }}
                  defaultValue={question.question}
                  variant="outlined"
                  onChange={(e) => setQuestion(e?.target?.value)}
                />
                <TextField
                  select
                  disabled={true}
                  size="small"
                  className={classes.fields}
                  label="Question Type"
                  defaultValue={question.type}
                  name="questionType"
                  id="questionType"
                  onChange={(e) => setQuestionType(e?.target?.value)}
                  variant="outlined"
                  style={{ marginBottom: 15 }}
                >
                  {types.map((type) => (
                    <MenuItem
                      key={type}
                      value={type}
                    >
                      {type}
                    </MenuItem>
                  ))}
                </TextField>
                { question.type === 'Multiple Choice' &&
                <div>
                  <TextField
                    disabled={checkDisabled(index)}
                    size="small"
                    className={classes.fields}
                    style={{ marginBottom: 15, marginRight: 25 }}
                    label="Correct answer"
                    variant="outlined"
                    defaultValue={question.correct_answer}
                    onChange={(e) => setCorrectAns(e?.target?.value)}
                  />
                  <TextField
                    disabled={checkDisabled(index)}
                    size="small"
                    className={classes.fields}
                    style={{ marginBottom: 15 }}
                    label="Incorrect answer"
                    variant="outlined"
                    defaultValue={question.incorrect_answers[0]}
                    onChange={(e) => setIncorrectAns1(e?.target?.value)}
                  />
                </div>
                }
                { question.type === 'Multiple Choice' &&
                <div>
                  <TextField
                    disabled={checkDisabled(index)}
                    size="small"
                    className={classes.fields}
                    style={{ marginBottom: 15, marginRight: 25 }}
                    label="Incorrect answer"
                    variant="outlined"
                    defaultValue={question.incorrect_answers[1]}
                    onChange={(e) => setIncorrectAns2(e?.target?.value)}
                  />
                  <TextField
                    disabled={checkDisabled(index)}
                    size="small"
                    className={classes.fields}
                    style={{ marginBottom: 15 }}
                    label="Incorrect answer"
                    variant="outlined"
                    defaultValue={question.incorrect_answers[2]}
                    onChange={(e) => setIncorrectAns3(e?.target?.value)}
                  />
                </div>
                }
                { question.type === 'True or False' &&
                <div>
                  <TextField
                    disabled={checkDisabled(index)}
                    size="small"
                    className={classes.fields}
                    style={{ marginBottom: 15, marginRight: 25 }}
                    label="Correct answer"
                    variant="outlined"
                    defaultValue={question.correct_answer}
                    onChange={(e) => setCorrectAns(e?.target?.value)}
                  />
                  <TextField
                    disabled={checkDisabled(index)}
                    size="small"
                    className={classes.fields}
                    style={{ marginBottom: 15 }}
                    label="Incorrect answer"
                    variant="outlined"
                    defaultValue={question.incorrect_answers[0]}
                    onChange={(e) => setIncorrectAns1(e?.target?.value)}
                  />
                </div>
                }
                { question.type === 'Identification' &&
                <div>
                  <TextField
                    disabled={checkDisabled(index)}
                    size="small"
                    className={classes.fields}
                    style={{ marginBottom: 15, width: '100%' }}
                    label="Answer"
                    variant="outlined"
                    defaultValue={question.correct_answer}
                    onChange={(e) => setCorrectAns(e?.target?.value)}
                  />
                </div>
                }
                <TextField
                  disabled={checkDisabled(index)}
                  size="small"
                  className={classes.fields}
                  style={{ marginBottom: 10 }}
                  label="Image link"
                  variant="outlined"
                  defaultValue={question.image_link}
                  onChange={(e) => setImage(e?.target?.value)}
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  {
                    checkDisabled(index) &&                   
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      style={{ marginRight: 10 }}
                      onClick={() => handleDisableQuestion(index)}
                    >
                      Update
                    </Button>
                  }
                  {
                    !checkDisabled(index) &&                   
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      style={{ marginRight: 10 }}
                      onClick={() => handleUpdateQuestion(index)}
                    >
                      Save
                    </Button>
                  }
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={() => handleUpdateQuestion(index, true)}
                 >
                  Delete
                </Button>
                </div>
              </div>
            ))}
          </div> // existing questions
        }
        {
          !questions.length &&
          <div className="settings__questions">
            <span style={{ fontSize: 30 }}>Add question</span>
            <div className="settings__select">
              { error && <ErrorMessage>{errorMsg}</ErrorMessage> }
              <TextField
                style={{ marginBottom: 25 }}
                label="Enter Question"
                variant="outlined"
                value={question}
                onChange={(e) => setQuestion(e?.target?.value)}
              />
              <TextField
                select
                label="Select Question Type"
                value={questionType}
                name="questionType"
                id="questionType"
                onChange={(e) => setQuestionType(e?.target?.value)}
                variant="outlined"
                style={{ marginBottom: 30 }}
              >
                {types.map((type) => (
                  <MenuItem
                    key={type}
                    value={type}
                  >
                    {type}
                  </MenuItem>
                ))}
              </TextField>
              { questionType && questionType === 'Multiple Choice' &&
              <div>
                <TextField
                  style={{ marginBottom: 25, marginRight: 25 }}
                  label="Correct answer"
                  variant="outlined"
                  onChange={(e) => setCorrectAns(e?.target?.value)}
                />
                <TextField
                  style={{ marginBottom: 25 }}
                  label="Incorrect answer"
                  variant="outlined"
                  onChange={(e) => setIncorrectAns1(e?.target?.value)}
                />
              </div>
              }
              { questionType && questionType === 'Multiple Choice' &&
              <div>
                <TextField
                  style={{ marginBottom: 25, marginRight: 25 }}
                  label="Incorrect answer"
                  variant="outlined"
                  onChange={(e) => setIncorrectAns2(e?.target?.value)}
                />
                <TextField
                  style={{ marginBottom: 25 }}
                  label="Incorrect answer"
                  variant="outlined"
                  onChange={(e) => setIncorrectAns3(e?.target?.value)}
                />
              </div>
              }
              { questionType && questionType === 'True or False' &&
              <div>
                <TextField
                  style={{ marginBottom: 25, marginRight: 25 }}
                  label="Correct answer"
                  variant="outlined"
                  onChange={(e) => setCorrectAns(e?.target?.value)}
                />
                <TextField
                  style={{ marginBottom: 25 }}
                  label="Incorrect answer"
                  variant="outlined"
                  onChange={(e) => setIncorrectAns1(e?.target?.value)}
                />
              </div>
              }
              { questionType && questionType === 'Identification' &&
              <div>
                <TextField
                  style={{ marginBottom: 25, width: '100%' }}
                  label="Answer"
                  variant="outlined"
                  onChange={(e) => setCorrectAns(e?.target?.value)}
                />
              </div>
              }
              { questionType &&
                <TextField
                  style={{ marginBottom: 25 }}
                  label="Enter image link (if applicable)"
                  variant="outlined"
                  onChange={(e) => setImage(e?.target?.value)}
                />
              }
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleInsertQuestion}
              >
                Insert question
              </Button>
            </div>
          </div>
        }
          <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              <h2 style={{ textAlign: 'center' }}>Add Question</h2>
              <div className="settings__select">
              { error && <ErrorMessage>{errorMsg}</ErrorMessage> }
              <TextField
                style={{ marginBottom: 25 }}
                label="Enter Question"
                variant="outlined"
                value={question}
                onChange={(e) => setQuestion(e?.target?.value)}
              />
              <TextField
                select
                label="Select Question Type"
                value={questionType}
                name="questionType"
                id="questionType"
                onChange={(e) => setQuestionType(e?.target?.value)}
                variant="outlined"
                style={{ marginBottom: 30 }}
              >
                {types.map((type) => (
                  <MenuItem
                    key={type}
                    value={type}
                  >
                    {type}
                  </MenuItem>
                ))}
              </TextField>
              { questionType && questionType === 'Multiple Choice' &&
              <div>
                <TextField
                  style={{ marginBottom: 25, marginRight: 25 }}
                  label="Correct answer"
                  variant="outlined"
                  onChange={(e) => setCorrectAns(e?.target?.value)}
                />
                <TextField
                  style={{ marginBottom: 25 }}
                  label="Incorrect answer"
                  variant="outlined"
                  onChange={(e) => setIncorrectAns1(e?.target?.value)}
                />
              </div>
              }
              { questionType && questionType === 'Multiple Choice' &&
              <div>
                <TextField
                  style={{ marginBottom: 25, marginRight: 25 }}
                  label="Incorrect answer"
                  variant="outlined"
                  onChange={(e) => setIncorrectAns2(e?.target?.value)}
                />
                <TextField
                  style={{ marginBottom: 25 }}
                  label="Incorrect answer"
                  variant="outlined"
                  onChange={(e) => setIncorrectAns3(e?.target?.value)}
                />
              </div>
              }
              { questionType && questionType === 'True or False' &&
              <div>
                <TextField
                  style={{ marginBottom: 25, marginRight: 25 }}
                  label="Correct answer"
                  variant="outlined"
                  onChange={(e) => setCorrectAns(e?.target?.value)}
                />
                <TextField
                  style={{ marginBottom: 25 }}
                  label="Incorrect answer"
                  variant="outlined"
                  onChange={(e) => setIncorrectAns1(e?.target?.value)}
                />
              </div>
              }
              { questionType && questionType === 'Identification' &&
              <div>
                <TextField
                  style={{ marginBottom: 25, width: '100%' }}
                  label="Answer"
                  variant="outlined"
                  onChange={(e) => setCorrectAns(e?.target?.value)}
                />
              </div>
              }
              { questionType &&
                <TextField
                  style={{ marginBottom: 25 }}
                  label="Enter image link"
                  variant="outlined"
                  onChange={(e) => setImage(e?.target?.value)}
                />
              }
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleInsertQuestion}
              >
                Insert question
              </Button>
            </div>
            </div>
          </Fade>
        </Modal>
      </div>
    </div>
  );
};

export default Questions;
